const WHATSAPP_WINDOW_NAME = "weme_whatsapp";

export function openWhatsApp(phoneNumber: string) {
  const encodedChatId = encodeURIComponent(phoneNumber);
  const url = `https://wa.me/${encodedChatId}`;
  window.open(url, WHATSAPP_WINDOW_NAME);
}

